import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { UserContext } from '@irian-ro/util-user';

type HasAnyRightGuardType = {
  setConfig: (config: { redirectUrl: string }) => CanActivateChildFn;
};

//const starting in uppercase in order to have the same API as with classes
export const HasAnyRightGuard: HasAnyRightGuardType = {
  setConfig: (config) => {
    return (childRoute) => {
      const userContext = inject(UserContext);
      const router = inject(Router);
      const data = childRoute.routeConfig['data'];
      const authorities = data ? data['authorities'] : [];

      if (authorities && authorities.length) {
        if (config) {
          if (userContext.hasAnyRightsGroup(authorities)) {
            return true;
          }

          return router.parseUrl(config.redirectUrl);
        } else {
          throw new Error('HasAnyRightGuard configuration is missing.  Use "HasAnyRightGuard.setConfig"');
        }
      }
      return true;
    };
  },
};
